import { CalendarEventModel } from '../models/calendar.model';
import { Observable } from 'rxjs';

export interface IAppPlatformCalendar {
    getCalendarEvents?(params?): Observable<CalendarEventModel[]>;
    createNewEvent?(event?: CalendarEventModel): any;
    editEvent?(event?: CalendarEventModel): any;
    deleteEvent?(event?: CalendarEventModel): any;
    getCalendarEventsOnLangChange?(events?: any): any;
}
